export default function layoutReducer(state = { ...defaultState }, action) {
  let newState = { ...state }
  switch (action.type) {
    case 'RESET_LAYOUT': {
      return { ...defaultState }
    }
    case 'SET_CURRENT_FLOW': {
      const { currentFlow } = action.payload
      newState.currentFlow = currentFlow
      return newState
    }
    case 'TOGGLE_TYPES_STEP_VIEW': {
      newState.typesStepView =
        newState.typesStepView === 'allTypes' ? 'customDeepSeating' : 'allTypes'
      return newState
    }
    default:
      return newState
  }
}

const defaultState = {
  currentFlow: null,
  typesStepView: 'allTypes',
}
